import * as Scrivito from "scrivito";
import React from "react";
import { debounce } from "lodash-es";
import { SearchInput } from "components/Inputs/SearchInput";
import { useTranslate } from "hooks";
import { useProjectListContext } from "../../hooks/useProjectListContext";

type ProjectSearchInputProps = {
  className?: string;
};

export const ProjectSearchInput = Scrivito.connect(
  ({ className }: ProjectSearchInputProps) => {
    const translate = useTranslate();
    const { setSearchQuery, searchQuery, setCurrentPageNo, currentPageNo } =
      useProjectListContext();
    const handleSearchQuery = (value: string) => {
      const isValueValid = checkIsValidQuery(value);

      if (!searchQuery && !isValueValid) {
        return;
      }

      if (
        checkIsValidQuery(searchQuery) &&
        !isValueValid &&
        typeof value === "string" &&
        value.length > 0
      ) {
        return;
      }

      setSearchQuery(value || null);

      if (currentPageNo > 1) {
        setCurrentPageNo(1);
      }

      Scrivito.navigateTo(() => Scrivito.currentPage(), {
        params: {
          page: "1",
        },
      });
    };

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const inputValue = e.target.value || "";
      handleSearchQuery(inputValue);
    };

    return (
      <SearchInput
        onChange={debounce(handleSearchChange, 1000)}
        testId="SEARCH_FIELD"
        classNames={className || ""}
        placeHolder={translate("SEARCH_FIELD_PLACEHOLDER")}
      />
    );
  },
);

const checkIsValidQuery = (value: string | null | undefined): boolean =>
  typeof value === "string" && value.length >= 3;
